type ContentType = 'text/html' | 'text/plain';

export const copyToClipboard = async (copyString: string, contentType: ContentType = 'text/plain') => {
  const blobInput = new Blob([copyString], { type: contentType });
  await navigator.clipboard.write([new ClipboardItem({ [blobInput.type]: blobInput })]);
};
